<div [className]="'autocompleteMaterial ' + (dropdownclass || '')" *ngIf="!isCombo">
  <label *ngIf="isFocus || search || showLabel" (click)="focus()">{{ label }}</label>
  <input #inputCombo type="text" class="input" [className]="'input ' + (id || '')" [disabled]="active"
    id="{{changeIDAutoComplete ? idElement : 'autocomplete'}}" [placeholder]="placeholder" [(ngModel)]="search"
    #matAutocompleteTrigger="matAutocompleteTrigger" (keydown.enter)="handleEnterKey($event)"
    (keydown)="keydown($event)" (keyup)="defaultFocus($event)" (ngModelChange)="onSearchInput($event);"
    (focus)="focus()" (blur)="isFocus = false; blurfct()" maskPass  [visible]="activeVisibleChamp ? visibleChamp : true" (click)="clickfct()" [matAutocomplete]="auto">
  <mat-autocomplete #auto="matAutocomplete" (opened)="onAutocompleteOpened()" (closed)="status.isopen = false"
    [displayWith]="getOptionText" [autoActiveFirstOption]="autoActiveFirstOption"
    [autoSelectActiveOption]="false" overlayPanelClass="autocompleteTextMaterial">
    <ng-template [ngIf]="status.isopen">
      <mat-option *ngFor="let item of results" [value]="item" (mousedown)="$event.preventDefault()"
        [ngClass]="{'mat-mdc-option-active': (selected && (item.id === selected.id)) || (results.length === 1)}">
        <div *ngIf="highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
            (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
        </div>
        <div *ngIf="!highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
            (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
        </div>
      </mat-option>
      <mat-option disabled *ngIf="results?.length === 0" >
        {{ isChargement || encoursDechargement ? 'Chargement ...' : 'Pas de correspondance'}}
      </mat-option>
      <!-- <mat-option disabled *ngIf=" (isChargement || encoursDechargement)">
        Chargement ...
      </mat-option> -->
    </ng-template>

  </mat-autocomplete>
</div>

<div class="autocompleteMaterial" [className]="'autocompleteMaterial ' + (dropdownclass || '')" *ngIf="isCombo">
  <!-- <button mat-button [matMenuTriggerFor]="menu" class="combo text-left" [className]="'combo text-left ' +  (id || '')">
    <span *ngIf="!isFixedHTML">{{ (search && search.length) ? search : placeholder}}</span>
    <div *ngIf="isFixedHTML" [innerHTML]="htmlCode"></div>
  </button>
  <mat-menu #menu="matMenu" panelId="ComboMaterial" yPosition="below" backdropClass="backdropClasscombo" overlayPanelClass="overlayPanelClassCombo"  panelClass="panelClassCombo">
    <button mat-menu-item class="dropdown-item" *ngFor="let item of results" (click)="selectItem(item)">
      <span  *ngIf="!highlight"
        [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
      </span>
      <span  *ngIf="highlight"
        [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
      </span>
    </button>
    <button mat-menu-item disabled *ngIf="results?.length === 0 && !isChargement">
      Pas de correspondance
    </button>
    <button mat-menu-item disabled *ngIf="isChargement">
      Chargement ...
    </button>
  </mat-menu> -->
  <label *ngIf="isFocus || search || showLabel" (click)="focus()">{{ label }}</label>
  <input *ngIf="!showArrowDown" #inputCombo type="text" class="input"
    [className]="'input combo ' + (id || '') + (isFixedHTML ? ' visibilityHidden' : '')" [disabled]="active"
    [placeholder]="placeholder" [(ngModel)]="search" id="{{changeIDAutoComplete ? idElement : 'autocomplete'}}"
    #matAutocompleteTrigger="matAutocompleteTrigger" (keydown.enter)="handleEnterKey($event)"
    (ngModelChange)="onSearchInput($event);" (click)="toggleDropdown()" [matAutocomplete]="auto" readonly>
  <input *ngIf="showArrowDown" #inputCombo type="text" class="input"
    [className]="'input combo ' + (id || '') + (isFixedHTML ? ' visibilityHidden' : '')" [disabled]="active"
    [placeholder]="placeholder" [(ngModel)]="search" id="{{changeIDAutoComplete ? idElement : 'autocomplete'}}"
    #matAutocompleteTrigger="matAutocompleteTrigger" (keydown.enter)="handleEnterKey($event)"
    (ngModelChange)="onSearchInput($event);" (click)="toggleDropdown()" [matAutocomplete]="auto"
    [value]="search || placeholder" readonly>
  <img *ngIf="rechercheIcone" alt="search" class="pull-right ng-star-inserted" (click)="toggleDropdown()"
    src="assets/images/icons/search.svg" id="recherche_pro_forma_btnsearch" style="
    position: relative;
    top: -31px;
    right: 5px;
">
  <label *ngIf="isFixedHTML" [className]="'htmlCode input combo ' + (id || '')"
    for="{{changeIDAutoComplete ? idElement : 'autocomplete'}}" [innerHTML]="htmlCode"></label>
  <div *ngIf="showArrowDown" class="arrowDownMat" (click)="toggleDropdown()">
    <span class="glyphicon glyphicon-menu-down" style="font-size: 22px;"></span>
  </div>
  <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="autoActiveFirstOption" [autoSelectActiveOption]="false"
    [displayWith]="getOptionText" overlayPanelClass="autocompleteTextMaterial" (opened)="onAutocompleteOpened()">
    <mat-option *ngFor="let item of results" [value]="item" (mousedown)="$event.preventDefault()"
      [ngClass]="{'mat-mdc-option-active': (selected && (item.id === selected.id)) || (results.length === 1)}">
      <div *ngIf="highlight"
        [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
      </div>
      <div *ngIf="!highlight"
        [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
      </div>
    </mat-option>
    <mat-option disabled *ngIf="results?.length === 0">
      {{ isChargement || encoursDechargement ?'Chargement ...' : 'Pas de correspondance'}}
    </mat-option>
    <!-- <mat-option disabled *ngIf="(isChargement || encoursDechargement)">
      Chargement ...
    </mat-option> -->
  </mat-autocomplete>
</div>